import React from 'react';

const ProjectCard = (props) => {
    const { img, name, description, gitLink, liveLink } = props.project;

    return (
        <div className="card mr-4 mt-4 col-md-3" style={{ borderRadius: "6px", border: "none" }}>
            <div className="d-flex justify-content-center mt-4" style={{ height: "200px" }}>
                <img className="card-img-top img-fluid" src={img} alt="" />
            </div>
            <div className="animated-btn-container">
                <div className="d-flex justify-content-center align-items-center flex-column mt-5">
                    <a className="text-decoration-none w-75" href={liveLink} target="blank">
                        <button type="button" className="btn btn-transparent font-weight-bold w-100" style={{ border: "1px solid #f5f5f7", color: "#f5f5f7" }}>
                            Live Site
                        </button>
                    </a>

                    <a className="text-decoration-none w-75" href={gitLink} target="blank">
                        <button type="button" className="btn btn-transparent font-weight-bold w-100 mt-2" style={{ border: "1px solid #f5f5f7", color: "#f5f5f7" }}>
                            Github
                        </button>
                    </a>
                </div>
            </div>

            <div className="card-body text-left">
                <h6 className="card-title font-weight-bolder name" style={{ color: "#0b9e43" }}>{name}</h6>
                <div className="card-title description">{description}</div>
            </div>
        </div>
    );
};

export default ProjectCard;